import React from "react";

import UpdatesPage from "../routes/updates-page";

const UpdatesTemplate = (props) => <UpdatesPage {...props} />;

export default UpdatesTemplate;
